export enum OutgoingDeliveryCreateUponEnum {
  OPENED_SO = 'opened_sales_order',
  PAID_INVOICE = 'paid_invoice',
}
